import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeadingIconWrapper = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacing.S8};
`
